import { render, staticRenderFns } from "./GoodsSliderPreview.vue?vue&type=template&id=48fcbe48&scoped=true&"
import script from "./GoodsSliderPreview.vue?vue&type=script&lang=js&"
export * from "./GoodsSliderPreview.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSliderPreview.vue?vue&type=style&index=0&id=48fcbe48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fcbe48",
  null
  
)

export default component.exports